import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Tag, Tooltip } from "antd";
import { useState,useEffect } from "react";
import { UserStudyCreationForm } from "../../Drawers/UserStudyCreationForm";
import * as Styles from "./ManageStudyStyles";
import { API_URL } from "../../../API/Config";
import ReTable from "../../../unity-ui-common/Components/ReTable/ReTable";
import { study } from "../../../API/UserManagement/Study";
import { convertDateInReadableFormat } from "../../../Helper/Methods";
import ImportStudyListModal from "../../StudyList/ImportStudyListModal";
import { Link } from "react-router-dom";

function ManageStudy() {
  const [selectedTableRow, setSelectedTableRow] = useState<string[]>([]);
  const [currEditingStudy, setCurrEditingStudy] = useState({});
  const [studyDrawerVisibility, setStudyDrawerVisibility] =
    useState<boolean>(false);
  const [isFileUploded, setIsFileUploded] = useState(false);
  const [isImported, setIsImported] = useState(false);
  const [studyDrawerType, setStudyDrawerType] = useState<string>("");
  const [importModal, setImportModal] = useState(false);
  const [studyData, setStudyData] = useState({});
  const [refreshTable, setRefreshTable] = useState(false);
  const [commonRefresh,setCommonRefresh] = useState<boolean>(false)
  
  const handleEditStudy = async (data: any) => {
    const studyData = await study.getStudy(data.id);
    setStudyData(studyData);
    setCurrEditingStudy(studyData);
    setStudyDrawerType("view");
    setStudyDrawerVisibility(true);
  };
  const tentant = JSON.parse(sessionStorage.getItem('selectedTenant') || '{}')?.name;
 

  const columns = [
    {
      title: "Study Name",
      dataIndex: "study_name",
      key: "study_name",
      width: 200,
      render: (record: any, data: any) => {
        return (
          <Tooltip title="view">
            <Link
              to=""
              onClick={() => {
                handleEditStudy(data);
              }}
              style={{ cursor: "pointer", color: "" }}
            >
              {record}
            </Link>
          </Tooltip>
        );
      },
    },
    {
      title: "Study Number",
      dataIndex: "study_number",
      key: "study_number",
      width: 200,
    },
    {
      title: "Blinded",
      dataIndex: "blinded",
      key: "blinded",
      width: 200,
      render: (record: any) => {
        const text = record === true ? "Yes" : "No";
        const color = record === true ? "green" : "red";
        return (
          <Tag color={color} title="status">
            {text}
          </Tag>
        );
      },
    },
    {
      title: "Sponsor",

      dataIndex: "sponsor_name",
      key:"sponsor_name",
      width: 200,
    //   render: (record: any) => {
    //     const text = record === 1 ? "Active" : "Inactive";
    //     const color = record === 1 ? "green" : "red";
    //     return (
    //       <Tag color={color} title="status">
    //         {text}
    //       </Tag>
    //     );
    //   },
    },
    {
      title: "Study Type",
      dataIndex: "study_type",
      key:"study_type",
      width: 200,
    },
    {
        title: "Study Phase",
        dataIndex: "study_phase",
        key:"study_phase",
        width: 200,
    },
    {
        title: "Status",
        dataIndex: "status",
        key:"status",
        width: 200,
        render: (record: any) => {
              const text = record === 1 ? "Active" : "Inactive";
              const color = record === 1 ? "green" : "red";
              return (
                <Tag color={color} title="status">
                  {text}
                </Tag>
              );
            }
      },
      {
        title: "Study Product",
        dataIndex: "study_product",
        key:"study_product",
        width: 200,
        render: (record: any) => {
          return Array.isArray(record) ? record.join(", ") : record || "-";
        },
      },
      {
        title: "Last Modified Date",
        dataIndex: "updated_at",
        key:"updated_at",
        width: 200,
        render: (value: any, record: any) => {
          const text = record.updated_at
            ? `${convertDateInReadableFormat(record.updated_at)}`
            : "-";
          return text;
        },
      },
    
    // {
    //   title: "Sponsor/MAH with roles",
    //   dataIndex: "roleMatrices",
    //   render: (roleMatrices: any) => {
    //     return (
    //       <div>
    //         {roleMatrices?.map((mt: any) => {
    //           return <p style={{margin: 0}}>{`${mt?.tenant}: ${mt?.roles.join(", ")}`}</p>;
    //         })}
    //       </div>
    //     );
    //   },
    // },
  ];
  useEffect(()=>{
    setRefreshTable(commonRefresh)
    },[commonRefresh])
  return (
    <Styles.Container>
      <UserStudyCreationForm
        drawerType={studyDrawerType}
        visibility={studyDrawerVisibility}
        setStudyDrawerType={setStudyDrawerType}
        setStudyDrawerVisibility={setStudyDrawerVisibility}
        currEditingStudy={currEditingStudy}
        studyData={studyData}
        setCommonRefresh={setCommonRefresh}
      />
      <ReTable
        name="All Records"
        title="All Records"
        columns={columns}
        columnOptions={{
          sorting: {
            columns: [
              "study_name",
              "study_number",
              "blinded",
              "sponsor_name",
              "study_type",
              "study_phase",
              "status",
              "study_product",
              "updated_at",
            ],
            sortingDirections: ["ascend", "descend"],
          },
          filter: {
            filterSearch: true,
            columns: [
              "study_name",
              "study_number",
              {
                key: "blinded",
                items: [
                  {
                    text: "Yes",
                    value: true,
                  },
                  {
                    text: "No",
                    value: false,
                  },
                ],
              },
              "sponsor_name",
              "study_type",
              "study_phase",
              {
                key: "status",
                items: [
                  {
                    text: "Active",
                    value: 1,
                  },
                  {
                    text: "Inactive",
                    value: 0,
                  },
                ],
              },
              "study_product",
              {
                key: "updated_at",
                action: (date: any) =>
                  date ? convertDateInReadableFormat(date) : "-",
              },
            ],
          },
        }}
        refresh={refreshTable}
        scroll={{
          x: 800,
          y: 500,
        }}
        selectAllOnlyCurrentPage={true}
        rowSelection={{
          selectedRowKeys: selectedTableRow,
          type: "checkbox",
          setSelectedRowKeys: setSelectedTableRow,
          rowKey: "id",
        }}
        uniView={{
          uniView: "study",
          viewName: "allStudy",
          apiUrl: API_URL,
          option: {
            orderBy: {
              key: "updated_at",
              order: "DESC",
            },
            limit: 10,
          },
        }}
        exportOption={{
          csv: {},
        }}
        headerButtons={[
          {
            title: "Import",
            icon: <PlusOutlined />,
            onClick: () => {
              setImportModal(!importModal);
            },
            visibility: true,
          },
          //******************** */
          {
            title: "Add New",
            icon: <PlusOutlined />,
            onClick: () => {
              setStudyDrawerType("create");
              setStudyDrawerVisibility(true);
            },
          },
        ]}
      />
      {/* ======================================= */}
      <ImportStudyListModal
        visibility={importModal}
        setVisibility={setImportModal}
        isImported={isImported}
        setIsImported={setIsImported}
        setIsFileUploded={setIsFileUploded}
        isFileUploded={isFileUploded}
        setCommonRefresh={setCommonRefresh}
        // getTableData={getTableData}
      />
    </Styles.Container>
  );
}

export default ManageStudy;
